import { Outlet } from 'react-router-dom';

export const Q_CompatibilityShort = () => {
  return <Outlet />;
};
